import { Box, Divider, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useFormArray } from 'shared/hooks/use-form-array';
import { Timeslot } from './time-slot';
import { SegmentsForEdit, TimeSlotFormContext } from './time-slot.types';

export const TimeSlotWrapper = ({
  isCreateMode,
  additionalAvailabilities,
}: {
  isCreateMode: boolean;
  additionalAvailabilities?: SegmentsForEdit[];
}) => {
  const timeslots = useFormArray<TimeSlotFormContext>('availability', {
    utcStartDateTime: null,
    utcEndDateTime: null,
  });
  const { watch } = useFormContext<TimeSlotFormContext>();
  const workerId = watch('workerSelect');

  return (
    <StyledContainer>
      {timeslots.fields.map((timeslot, index) => (
        <Box key={timeslot.id} data-testid="timeslot-row">
          <Timeslot
            index={index}
            additionalAvailabilities={additionalAvailabilities}
            handleDelete={timeslots.deleteElement}
            handleAdd={timeslots.addElement}
            canAdd={isCreateMode}
            isWorkerFilled={!!workerId}
          />
          {index < timeslots.fields.length - 1 && <StyledDivider />}
        </Box>
      ))}
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
